import { insertOrUpdateBlock } from "@blocknote/core";
import type { DefaultReactSuggestionItem } from "@blocknote/react";
import type { BnEditor } from "blocks-schema";
import { Icon, iconStyles } from "ui";

export function insertImageWithChildrenBlockItems(editor: BnEditor): DefaultReactSuggestionItem[] {
  return [
    {
      title: "Image with Text",
      onItemClick: () => {
        editor.transact(() => {
          const block = insertOrUpdateBlock(editor, {
            type: "imageWithChildrenBlock",
            props: {
              image: "",
              alt: "",
              url: "",
              caption: "",
              percentageWidth: 50,
              order: "imageText",
            },
            children: [{ type: "columnBlock", content: undefined, children: [{ type: "paragraph" }] }],
          });
          editor.setTextCursorPosition(block);
        });
      },
      aliases: ["image text", "columns"],
      group: "Content",
      icon: <Icon className={iconStyles.neutral600} iconType="ColumnsImageAndText" />,
      subtext: "Add an image with text content beside it",
    },
    {
      title: "Text with Image",
      onItemClick: () => {
        editor.transact(() => {
          const block = insertOrUpdateBlock(editor, {
            type: "imageWithChildrenBlock",
            props: {
              image: "",
              alt: "",
              url: "",
              caption: "",
              percentageWidth: 50,
              order: "textImage",
            },
            children: [{ type: "columnBlock", content: undefined, children: [{ type: "paragraph" }] }],
          });
          editor.setTextCursorPosition(block);
        });
      },
      aliases: ["text image", "columns"],
      group: "Content",
      icon: <Icon className={iconStyles.neutral600} iconType="ColumnsTextAndImage" />,
      subtext: "Add text content with an image beside it",
    },
  ];
}
